<template>
    <div class="root" v-loading="loading">


        <topmenu></topmenu>




        <!-- content -->

        <div class="container theme-showcase">


            <div style="margin-top: 20px; display: flex; align-items: center;">
                <div style="flex:1;">
                    <el-button type="primary" icon="el-icon-plus" size="medium" @click="add">添加</el-button>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-refresh" size="medium" @click="refresh">刷新</el-button>
                </div>
            </div>

            <div style="margin: 16px 0;">
                <el-table :data="list" border style="width: 100%">
                    <el-table-column prop="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column prop="nickname" label="昵称" width="200">
                    </el-table-column>
                    <el-table-column prop="username" label="账号" width="160">
                    </el-table-column>
                    <el-table-column prop="createtime" label="创建时间" width="190">
                    </el-table-column>
                    <el-table-column prop="permission" label="权限" width="474">
                    </el-table-column>
                    <el-table-column label="操作" width="95">
                        <template slot-scope="scope">

                            <el-button size="mini" type="primary" icon="el-icon-edit" circle
                                @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button size="mini" type="danger" icon="el-icon-delete" circle
                                v-if="scope.row['username'] != 'jinyuan'"
                                @click="handleDelete(scope.$index, scope.row)"></el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin:12px 0;">
                    <div v-if="total > 1">
                        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                            :current-page.sync="currentPage" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>


            <el-dialog title="类别用户" :visible.sync="dialogFormVisible" width="650px">
                <el-form :model="form" label-width="80px">
                    <el-form-item label="昵称:" required :error="nameErr">
                        <el-input v-model="Name"  clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户名:" required :error="userNameErr">
                        <el-input v-model="UserName"  clearable  :readonly="id>0"></el-input>
                    </el-form-item>
                    <el-form-item label="密码:" required :error="passwordErr" v-if="!id>0">
                        <el-input v-model="password" type="password" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="权限:">
                        <div>
                            <el-checkbox-group v-model="permissions2">
                                <el-checkbox v-for="per in permissions" :label="per.name" :key="per.id"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="submit">确定</el-button>
                </div>
            </el-dialog>


            <div style="height: 35px;"></div>
        </div>
        <!-- content -->

    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../home/components/topmenu'

export default {
    name: 'visitorlist',
    data: function () {
        return {
            list: [],
            loading: false,
            id: '',
            Name: '',
            Ordering: 0,
            dialogFormVisible: false,
            nameErr: '',
            userNameErr:'',
            UserName:'',
            total: 0,
            currentPage: 1,
            permissions: '',
            permissions2: [],
            password:'',
            passwordErr:''
        }
    },
    components: {
        topmenu
    },
    methods: {
        add() {
            this.dialogFormVisible = true;
            this.id = '';
            this.Name = '';
            this.Ordering = '';
            this.nameErr = "";
            this.permissions2=[];
            this.UserName="";
            this.userNameErr='';
            this.password='';
            this.passwordErr='';
        },
        refresh() {
            console.log(this.currentPage);
            this.loadData(this.currentPage);
        },
        loadPermission() {
            console.log("loadPermission");
            this.loading = true;
            var url = "/api/User/permissionList";
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/User/permissionList',
                {
                    skip: 0,
                    limit: 100,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadPermissionSucc)
        },
        loadPermissionSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.permissions = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        loadData(page) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/User/userList',
                {
                    skip: (page - 1) * 10,
                    limit: 10,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.total = res.total;
                this.list = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        submit() {
            if (this.Name == '') {
                this.nameErr = "请输入";
                return;
            } else {
                this.nameErr = "";
            }
            if (this.UserName == '') {
                this.userNameErr = "请输入";
                return;
            } else {
                this.userNameErr = "";
            }
            if (this.password == '') {
                this.passwordErr = "请输入";
                return;
            } else {
                this.passwordErr = "";
            }
            this.onSubmit();
        },
        onSubmit() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));

            var uid = userJson.uid;
            var token = userJson.token;
            var url = 'api/User/editUser';
            if (this.id > 0) {
                url = 'api/User/editUser';
            }
            axios.post(url,
                {
                    uid: uid,
                    token: token,
                    id: this.id,
                    name: this.Name,
                    password:this.password,
                    username:this.UserName,
                    permissions:this.permissions2,
                    ordering: this.Ordering
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.dialogFormVisible = false;
                this.$message({
                    message: '操作成功!',
                    type: 'success',
                    onClose: () => {
                    }
                });
                this.loadData(1);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        handleEdit(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);
            this.id = id;
            this.nameErr = "";
            this.Name = row.nickname;
            this.userNameErr = '';
            this.UserName = row.username;
            this.password = "jy123456";
            this.passwordErr='';
            this.permissions2 = row.permissionArr.map(f=>f.name);
            console.log(this.permissions2);
            this.dialogFormVisible = true;
        },


        handleDelete(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);

            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delCate(id);
            });

        },

        delCate(id) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/User/deleteUser',
                {
                    id: id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.delCateSucc)
        },
        delCateSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData(1);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        handleCurrentChange(page) {
            console.log(page)
            this.loadData(page);
        },
    },
    mounted() {

        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
        this.loadData(1);
        this.loadPermission();
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.root>>>.topmenuitem:nth-child(4) {
    color: #fff;
    background-color: #080808;
}
</style>



// WEBPACK FOOTER //
// src/pages/visitors/visitorlist.vue